import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class Base64UrlService {
    public Encode(value: string): string {
        return btoa(value)
            .replace(/\+/g, '-')
            .replace(/\//g, '_')
            .replace(/=+$/, '');
    }

    public Decode(value: string): string {
        const m = value.length % 4;

        return atob(
            value.replace(/-/g, '+')
                .replace(/_/g, '/')
                .padEnd(value.length + (m === 0 ? 0 : 4 - m), '=')
        );
    }
    public urlDecode(str: string): string {
        const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
        const paddedBase64 = base64.padEnd(base64.length + ((4 - (base64.length % 4)) % 4), '=');
        const binary = atob(paddedBase64);
        const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));

        return new TextDecoder().decode(bytes);
    }

    public urlEncode(str: string): string {
        const bytes = new TextEncoder().encode(str);
        let binary = '';
        const chunkSize = 0x8000;

        for (let offset = 0; offset < bytes.length; offset += chunkSize) {
            binary += String.fromCharCode(...bytes.subarray(offset, offset + chunkSize));
        }

        return btoa(binary);
    }
}
